/**
 * Homepage hero carousel images.
 *
 * Add files under `web-client/public/images/hero/`, then append their public
 * paths here (served from `/images/hero/...`).
 */
export const HOME_HERO_IMAGES: readonly string[] = [
  '/images/hero/lb-hero1.webp',
  '/images/hero/lb-hero2.webp',
  '/images/hero/lb-hero3.webp',
  '/images/hero/lb-hero4.webp',
  '/images/hero/lb-hero5.webp',
  '/images/hero/lb-hero6.webp',
];

/** Time each slide is visible before advancing (ms). */
export const HOME_HERO_SLIDE_INTERVAL_MS = 5000;

/** Crossfade duration (ms). */
export const HOME_HERO_TRANSITION_MS = 800;
